import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import moment from "moment";
// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import axios from "axios";
import DataTable from "react-data-table-component";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import { checkUserPermission } from "../../../../common/UserPermission";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import { toastSuccess } from "../../../../common/Toast";
import {
  DELETE_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import * as XLSX from "xlsx";
import CommonMatrialReactTableServerSideRender from "../../../../components/Datatable/CommonMatrialReactTableServerSideRender";
import { handleSaveColumnOrder } from "../../../../common/common";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-transfer";
let PERMISSION_EDIT = "/manage-transfer/:id";
let PERMISSION_DELETE = "delete-transfer";
// let PERMISSION_MANAGE_DELETED_APPOINTMENTS = "/deleted-appointments";
// let PERMISSION_APPOINTMENTS_CATEGORY = "/manage-categories";
// let PERMISSION_DELETE_SELECTED = "delete-selected-appointments";

const Transfer = () => {
  const paramObject = useParams();
  let selectData = [];
  let pathforpdf = "";
  let selectDatas = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(5);
  const loginuserid = localStorage.getItem("ID");

  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedAppointmentsCheckboxs, setselectedAppointmentCheckbox] =
    useState("");
  const [selectedItemskitCheckEmails, setselectedItemskitCheckEmails] =
    useState("");
  const [selectedItemskitCheckpathforpdf, setselectedItemskitCheckpathforpdf] =
    useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);

  const navigate = useNavigate();

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_File.xlsx`);
  };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/transferhistorylisting?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData?.list);
        setRowCount(res.data.ResponseData?.list[0]?.TotalRecord);
        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      // for get detlais form id
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      const selectedItemsCheckboxIDs =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedAppointmentCheckbox(selectedItemsCheckboxIDs);

      const datasplitforpath = selectedItemsCheckboxIDs?.split(",");
      pathforpdf = datasplitforpath?.join("~");
      setselectedItemskitCheckpathforpdf(pathforpdf);

      // get emails of selectdids
      setSelectedRows(e.selectedRows.map((x) => x.Email));
      selectData[currentPage] = e.selectedRows.map((x) => x.Email);
      const selectedItemsCheckboxEmails =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedItemskitCheckEmails(selectedItemsCheckboxEmails);
    }
  };

  // const handleDeletePopup = (pID,rows) => {
  //   console.log("pID", pID);
  //   console.log("selectedItemskitCheckboxs", selectedAppointmentsCheckboxs);
  //   const data=rows.map((el) => el.original.ID).join(",")
  //   const deleteRequestParam = {
  //     // id: pID || selectedAppointmentsCheckboxs,
  //     id: data,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  //   // setShowDateFilterModal(true);
  //   setDeleteModalOpen(true)
  //   // window.location.reload(true);
  // };

  const handleDeletePopup = (
    id,
    quickbookids,
    fromqbid,
    toqbid,
    amount,
    row,
    field
  ) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    let fromquickid;
    let toquickid;
    //let ammount ;
    let rowdata = [];
    if (field == "multipleRowInactive") {
      data = row.map((el) => el.original.ID).join(",");

      // ammount = row.map((el) => el.original.TransferAmount).join(",");
      rowdata = row.map((el) => {
        return {
          quickbookid: el.original.QuickbookId,
          // type: el.original.ReceivingTypeId
          amount: el.original.TransferAmount,
          fromquickid: el.original.Quickbookidfrom,
          toquickid: el.original.QuickbookidTo,
        };
      });
      console.log(rowdata, "roedata");
    } else {
      data = id;

      const obj = {
        quickbookid: quickbookids,
        amount: amount,
        fromquickid: fromqbid,
        toquickid: toqbid, // type: receivingtypeid
      };
      rowdata.push(obj);
    }
    const deleteRequestParam = {
      priceruleids: data,
      fromaccquickbook: fromquickid,
      toaccquickbook: toquickid,
      // transferammount : ammount,
      loginuserid: loginuserid,
      quickbookarray: rowdata,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  const contextActions = useMemo(() => {
    return (
      <>
        <div className="row px-2">
          <div className="col-12 align-self-center">
            {checkUserPermission(PERMISSION_DELETE) && (
              <button
                type="button"
                className="btn btn-primary btn-sm pull-left "
                // data-bs-toggle="modal"
                // data-bs-target="#DeleteConfirmationModal"
                onClick={() => handleDeletePopup()}
              >
                <i className="fa fa-trash fa-sm" /> Delete Selected
              </button>
            )}
          </div>
        </div>
      </>
    );
  }, [data, selectedRows, toggleCleared]);

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  useEffect(() => {
    console.log();
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [columnFilters, globalFilter, pagination, sorting]);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "Id",
      size: 120,
      Cell: checkUserPermission(PERMISSION_EDIT)
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() => navigate(`/manage-transfer/${row.original.ID}`)}
            >
              {row.original.ID}
            </Box>
          )
        : null,
      filterFn: "contains",
    },
    {
      header: "Account From",
      accessorKey: "AccountFrom",
      size: 130,
    },
    {
      header: "Account To",
      accessorKey: "AccountTo",
      size: 130,
    },
    {
      header: "Transfer Amount",
      accessorKey: "TransferAmount",
      size: 120,
    },
    {
      header: "Transfer Date",
      accessorKey: "TransferDate",
      Cell: ({ row }) => moment(row.original.TransferDate).format("MM/DD/YYYY"),
      size: 120,
    },
    {
      header: "Employee Name",
      accessorKey: "EmployeeName",
      size: 130,
    },
    {
      header: "QB SyncStatus",
      accessorKey: "SyncStatusName",
      size: 120,

      Cell: ({ row }) =>
        row.original.SyncStatusName == "Completed" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : row.original.SyncStatusName == "Failed" ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : (
          ""
        ),
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Created On",
      accessorKey: "CreatedOn",
      Cell: ({ row }) =>
        moment(row.original.CreatedOn).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Memo",
      accessorKey: "Memo",
      size: 100,
    },
  ]);

  const handleDateFilterConfirm = () => {
    console.log("api call delete");
    const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
    console.log("deleteRequestParam: 12", deleteRequestParam);
    // console.log("deleteApiUrl: ", deleteApiUrl);
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/transferhistorydelete`,
        deleteRequestParam,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then(() => {
        toastSuccess(DELETE_MESSAGE);
        // window.location.reload();
        window.location.href = window.location.href;
      });

    setShowDateFilterModal(false);
  };

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  // store checkbox checked values to hide or show columns
  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }

  // generate new columns according to hiddenColumns data and pass it as datatable column

  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  const renderRowActionMenuItems = ({ row, table }) => [
    checkUserPermission(PERMISSION_EDIT) ? (
      <MenuItem
        key="edit"
        onClick={() => navigate(`/manage-transfer/${row.original.ID}`)}
      >
        Edit
      </MenuItem>
    ) : null,
    checkUserPermission(PERMISSION_DELETE) ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"
        title="Delete"
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={() =>
          handleDeletePopup(
            row.original.ID,
            row.original.QuickbookId,
            row.original.Quickbookidfrom,
            row.original.QuickbookidTo,
            row.original.TransferAmount,
            "",
            ""
          )
        }
      >
        Delete
      </MenuItem>
    ) : null,
    row.original.Attachements ? (
      <a
        className="dropdown-item confirm-text"
        href={row.original.Attachements}
        target="_blank"
        title="Attachment"
      >
        <MenuItem title="Attachment">Attachments</MenuItem>
      </a>
    ) : (
      ""
    ),
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {/* {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                  (checkUserPermission("mark-inactive") ? (
                    <Button
                      // size="small"
                      class="btn btn-sm btn-secondary"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleDeletePopup(
                          "",
                          "",
                          table.getSelectedRowModel().rows,
                          "multipleRowInactive"
                        )
                      }
                      // startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Mark InActive
                    </Button>
                  ) : (
                    " "
                  ))} */}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h4 className="page-title"> Dashboard: Transfer List</h4> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Transfer List</li>
              </ul>
            </div>
          </div>
          <div className="d-flex flex-row-reverse mb-3">
            {/* <div className="col-md-3">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm "
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div> */}

            <div className="row">
              <div className="btn-group  pull-right ms-2">
                {checkUserPermission("export-button") ? (
                  <button
                    // className="btn btn-added pull-right"
                    className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                    style={{ width: "max-content" }}
                    onClick={() => onBtExport([], "AllData")}
                  >
                    <i
                      className="fa fa-download mr-2"
                      style={{ color: "#111930" }}
                    ></i>
                    Export Visible Column
                    {/* <i class="fa-thin fa-download"></i> */}
                  </button>
                ) : (
                  ""
                )}
                {checkUserPermission(PERMISSION_ADD) && (
                  <Link
                    to="/manage-transfer"
                    className="btn btn-primary btn-sm pull-right mr-2"
                    style={{ width: "max-content", borderRadius: "8px" }}
                  >
                    <i className="fa fa-plus me-2 lg"></i>
                    New Transfer
                  </Link>
                )}
              </div>
            </div>
            <div
              className="cursor-pointer mr-3 mt-1"
              onClick={() =>
                handleSaveColumnOrder(
                  loginuserid,
                  "TransferHistory",
                  columnOrder,
                  token,
                  columnVisibility
                )
              }
              title="Lock Your Sequence"
              // onMouseEnter={() => setIcon(ColumnOrderIconHover)}
              // onMouseLeave={() => setIcon(ColumnOrderIcon)}
            >
              <i class="fa fa-lock columnsLock fs-4"></i>
            </div>
          </div>
          {/* <div className="row flex-row-reverse mt-2 mb-2">
            <div className="col-2 float-end">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div>
          </div> */}

          <CommonMatrialReactTableServerSideRender
            MainHeading="Sonar POS"
            ReportHeading="Transfer List"
            columns={columns}
            data={data}
            // startdate={startdate}
            // enddate={enddate}
            columnGrouping={[]}
            columnsVisibility={{}}
            enableRowActions={checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE) }
            enableRowSelection={true}
            renderRowActionMenuItems={renderRowActionMenuItems}
            renderTopToolbarCustomActions={renderTopToolbarCustomActions}
            density="comfortable"
            showGlobalFilter={true}
            showColumnFilters={false}
            expanded={true}
            pagination={{ pageIndex: 0, pageSize: 25 }}
            rowCount={rowCount}
            setColumnFilters={setColumnFilters} // for termp comment filteron column
            setGlobalFilter={setGlobalFilter}
            setPagination={setPagination}
            setSorting={setSorting}
            setColumnOrder={setColumnOrder}
            setColumnVisibility={setColumnVisibility} //setColumnVisibility
            state={{
              columnFilters, // for termp comment filteron column
              // globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
              columnOrder,
              columnVisibility,
            }}
          />
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.accountingBaseUrl}/chartofaccounts/transferhistorydelete`}
        id={4}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default Transfer;
